import { DefaultError } from "@tanstack/react-query";
import { Button } from "components/atoms";
import { MagellanPopups } from "components/molecules";
import { Form } from "components/organisms";
import { saleChannelInitialValue } from "components/organisms/forms/sales-channel/SalesChannelForm";
import { useHasPermission } from "hooks";
import { useParamId } from "hooks/useParamId";
import middleware from "middleware";
import { useTranslation } from "react-i18next";
import { PiPencilSimpleLine } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import { PopupActions } from "reactjs-popup/dist/types";
import {
  useDeleteSaleChannel,
  useGetSalesChannel,
} from "services/salesChannel/index";
import { getFinanceStatisticsBackPath } from "utils/nav/financeStatisticsNavigation.utils";
import { onErrorShowToast } from "utils/service/errorHandler";

const SaleChannel = () => {
  const salesChannelId = useParamId("/settings/sales-channel/");
  const navigate = useNavigate();
  const { state: locationState } = useLocation();
  const { data, isLoading } = useGetSalesChannel(salesChannelId);
  const { t } = useTranslation();
  const hasPermission = useHasPermission();


  const removeSaleChannel = useDeleteSaleChannel();

  const handleDeleteent = async (actions: PopupActions) => {
    await removeSaleChannel.mutateAsync(salesChannelId, {
      onError: (error: DefaultError) => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate(`/settings/sales-channel`),
    });
  };

  const backPath = getFinanceStatisticsBackPath(
    'settings/sales-channel',
    locationState
  );

  return (
    <Form.SaleChannel
      i18nextPrefix=""
      initialValues={
        data
          ? middleware.saleChannel.queryToForm(data)
          : saleChannelInitialValue
      }
      onSubmit={() => {}}
      tittle={t("saleChannel.create-sales")}
      status={{ displayMode: true, isLoading }}
      backPath={backPath}
      topbarContent={
        <div className="flex justify-end">
          {hasPermission('SalesChannelPermissionsLIST**', 64) && (
            <Button
              isClear
              onlyIcon
            onClick={() => {
              navigate(`/settings/sales-channel/edit/${salesChannelId}`, {
                replace: true,
              });
            }}
          >
              <Button.Description description={t('button.edit')} />

              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}
          {hasPermission('SalesChannelPermissionsLIST**', 128) && !data?.isPredefined && (
            <MagellanPopups.DeleteWarning onRemove={handleDeleteent} />
          )}
        </div>
      }
    />
  );
};

export default SaleChannel;
